export default [
    {
        name: "organizationId",
        label: "Client",
        type: "list",
        helpText: "Client",
        url: "/organizations",
        filterValue: "name",
        errorMessage: "Client is required",
        validation: {
            required: true,
        },
        include: true,
        entityName: "organization",
    },
    {
        name: "signDate",
        label: "Sign Date",
        type: "date",
        helpText: "Sign Date",
        errorMessage: "Sign Date is required",
        validation: {
            required: true,
        },
    },
    {
        name: "endDate",
        label: "End Date",
        type: "date",
        helpText: "End Date",
        errorMessage: "End Date is required",
        validation: {
            required: true,
        },
    },
    {
        name: "collectionDate",
        label: "Collection Date",
        type: "date",
        helpText: "Collection Date",
        errorMessage: "Collection Date is required",
        validation: {
            required: false,
        },
    },
    {
        name: "invoiceDate",
        label: "Invoice Date",
        type: "date",
        helpText: "Invoice Date",
        errorMessage: "Invoice Date is required",
        validation: {
            required: false,
        },
    },
];
